import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import Text from "../../atoms/Text"
import LinkText from "../../atoms/LinkText"
import ContentCard from "../../molecules/ContentCard"
import KatahiraCamp01 from "../../../images/katahira_camp_01.jpg"
import KatahiraCamp02 from "../../../images/2020katahira.jpg"
import Zeami from "../../../images/zeami.png"
import ZeamiBook from "../../../images/zeami_book.jpg"
import OBOG from "../../../images/obog.jpg"

export default class MainContents extends Component {
  render() {
    const { isMobile } = this.props
    return (
      <Grid>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <ContentCard isMobile={isMobile} name="概要">
            <Text bold>
              片平ゼミは東大で唯一ブランドマーケティングが学べるゼミです。
            </Text>
            <Text>
              単位の出ない自主ゼミですが、単位以上に得るものがたくさんで、自主ゼミだからこそ柔軟なスタイルで学びを深めることができます。
            </Text>
            <Text>
              またゼミ外部との関わりが非常に強く、実際にブランド作りに携わる社会人と議論する機会が多くあります。
            </Text>
            <Text inlineBox>工学部や文学部など</Text>
            <Text bold inlineBox>
              他学部生も多く所属
            </Text>
            <Text inlineBox>
              しており、個性的なメンバーで構成されています。
            </Text>
            <Text>
              また、来年で37年目になるゼミでOBOGとの関わりも強いため、就活にも困りません。
            </Text>
            <Text bold inlineBox>
              毎週火曜16:00〜18:00
            </Text>
            <Text inlineBox>、片平先生の</Text>
            <Text bold inlineBox>
              丸の内のオフィス
            </Text>
            <Text inlineBox>で活動しています。</Text>
          </ContentCard>
        </Grid>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <ContentCard
            isMobile={isMobile}
            name="2019年度テーマ"
            images={[{ src: ZeamiBook }, { src: Zeami }]}
          >
            <Text>
              世阿弥の著作を輪読します。『風姿花伝』、『花鏡』などを収めた『世阿弥芸術論集』(新潮社)が教科書。
            </Text>
            <Text>
              字面の解釈に留まらず、議論の対象となっている事象の実例を、身の回りから持ち寄って自分ごととして納得することを目指します。
            </Text>
            <Text inlineBox>
              世阿弥本は輪読してブランド育成の基本的考え方を習得し、
            </Text>
            <LinkText border to="/projects" inlineBox>
              プロジェクト現場
            </LinkText>
            <Text inlineBox>でそれらを体験、体得していきます。</Text>
          </ContentCard>
        </Grid>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <ContentCard
            isMobile={isMobile}
            name="OBOG会"
            images={[{ src: OBOG, text: "今年行われたOBOG会の様子" }]}
          >
            <Text>毎年1月ごろにOBOG会を開催しています。</Text>
            <Text>歴史あるゼミなので多様な卒業生の方がいらっしゃいます。</Text>
          </ContentCard>
        </Grid>
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <ContentCard
            isMobile={isMobile}
            name="その他"
            images={[
              { src: KatahiraCamp01, text: "南部鉄器工房にて" },
              { src: KatahiraCamp02, text: "長野県北岳にて" },
            ]}
          >
            <Text>片平ゼミはゼミ生同士が仲がいいのも特徴です。</Text>
            <Text>
              昨年の合宿では盛岡に赴き、南部鉄器の工房や小岩井農場を訪れました。
            </Text>
            <Text>
              また、ゼミ後にはアフターがあることが多く、同期旅行やクリパなど普段から遊びも多く企画されています。
            </Text>
          </ContentCard>
        </Grid>
      </Grid>
    )
  }
}
